import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import { createIncident, deleteIncident, fetchIncident, fetchIncidentById, fetchStaffManager, fetchStaffTeacher, incidentSentParent, updateIncident } from "../../../service/api";

export const getIncident = createAsyncThunk(
    "incident/getAll",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchIncident(params)
            console.log("incident ", response)
            return response.data.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)

export const getManagerList = createAsyncThunk(
    "incident/getManager",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchStaffManager(params)
            console.log("manager ", response)
            return response.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)

export const getTeacherList = createAsyncThunk(
    "incident/getTeacher",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchStaffTeacher(params)
            console.log("teacher ", response)
            return response.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)
export const getIncidentById = createAsyncThunk(
    "incident/byId",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchIncidentById(params)
            console.log("incident by id", response)
            return response.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)


export const deleteIncidents = createAsyncThunk(
    "incident/delete",
    async (formValue, { rejectWithValue }) => {
        try {
            const response = await deleteIncident(formValue)
            if (response.status === 201) {
                console.log("incident delete", response)
            }
        } catch (error) {
            return rejectWithValue(error.response || error)
        }
    }
)




export const addIncident = createAsyncThunk(
    "incident/add",
    async (formValue, { rejectWithValue }) => {
        try {
            const response = await createIncident(formValue);

            if (response.status === 201 && response.data?.data?.pdfPath) {
                const pdfUrl = response.data.data.pdfPath;
                window.open(pdfUrl, '_blank');
            }

            return response.data;

        } catch (error) {
            return rejectWithValue(error.response || error);
        }
    }
);


export const editIncident = createAsyncThunk(
    "incident/edit",
    async (formValue, { rejectWithValue }) => {
        try {
            const response = await updateIncident(formValue)
            if (response.status === 201 && response.data?.data?.pdfPath) {
                const pdfUrl = response.data.data.pdfPath;
                window.open(pdfUrl, '_blank');
            }

            return response.data;

        } catch (error) {
            return rejectWithValue(error.response || error)
        }
    }
)

export const editIncidentSentParent = createAsyncThunk(
    "incident/sentParent",
    async (formValue, { rejectWithValue }) => {
        try {
            const response = await incidentSentParent(formValue)
            if (response.status === 201) {
                console.log(response)
            }
        } catch (error) {
            return rejectWithValue(error.response || error)
        }
    }
)

const incidentSlice = createSlice({
    name: "incidents",
    initialState: {
        incidentList: [],
        managerList: [],
        teacherList: [],
        incidentById: {},
        isLoading: false,
        actionLoader: false,
        error: null,
        totalPage: 0,
        current: 1,
        limit: 10,
        searchParams: ""
    },
    reducers: {
        setPagination: (state, action) => {
            state.current = action.payload;
        },
        setSearchParams: (state, action) => {
            state.searchParams = action.payload;
        },
    },

    extraReducers: (builder) => {
        builder
            //GET
            .addCase(getIncident.pending, (state) => {
                state.isLoading = true,
                    state.error = null
            })
            .addCase(getIncident.fulfilled, (state, action) => {
                state.isLoading = false;
                state.incidentList = action.payload.data;
                state.totalPage = action.payload.totalPages
            })

            .addCase(getIncident.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload
            })
            // GET MANAGER
            .addCase(getManagerList.pending, (state) => {
                state.isLoading = true,
                    state.error = null
            })
            .addCase(getManagerList.fulfilled, (state, action) => {
                state.isLoading = false;
                state.managerList = action.payload.data;
            })

            .addCase(getManagerList.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload
            })

            // GET TEACHER
            .addCase(getTeacherList.pending, (state) => {
                state.isLoading = true,
                    state.error = null
            })
            .addCase(getTeacherList.fulfilled, (state, action) => {
                state.isLoading = false;
                state.teacherList = action.payload.data;
            })

            .addCase(getTeacherList.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload
            })
            //event by id
            .addCase(getIncidentById.pending, (state) => {
                state.isLoading = true,
                    state.error = null
            })

            .addCase(getIncidentById.fulfilled, (state, action) => {
                state.isLoading = false;
                state.incidentById = action.payload.data;
            })

            .addCase(getIncidentById.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload
            })

            // POST
            .addCase(addIncident.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(addIncident.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(addIncident.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })


            // delete
            .addCase(deleteIncidents.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(deleteIncidents.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(deleteIncidents.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })

            // PUT
            .addCase(editIncident.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(editIncident.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(editIncident.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })

             // PUT SENT TO PARENT
            .addCase(editIncidentSentParent.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(editIncidentSentParent.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(editIncidentSentParent.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })
    }
})

export const { setSearchParams, setPagination } = incidentSlice.actions;

export default incidentSlice.reducer;
